export const languageConstants = {
    SET_LANGUAGE: 'SET_LANGUAGE',
};
